import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./auth/ProtectedRoute";

import AuthPage from "./pages/AuthPage";
import Home2 from "./pages/Home2";
import LibraryPage from "./pages/LibraryPage";
import AboutUs from "./pages/AboutUs";
import WeightCalculator from "./pages/WeightCalculator";
import MySchedulePage from "./pages/Schedule";
import Header2 from "./layouts/Header2";
import Footer2 from "./layouts/Footer2";

import "./assets/vendor/switcher/switcher.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";
import "./assets/css/style.css";
import "./assets/css/mobile.css";

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [hash, pathname]);
  return null;
};

function App() {
  const Home2Layout = (
    <div className="page-wraper">
      <Header2 />
      <Home2 />
      <Footer2 />
    </div>
  );

  return (
    <AuthProvider>
      <ScrollToHash />
      <Routes>

        {/* Public Routes */}
        <Route path="/" element={Home2Layout} />
        <Route path="/home2" element={Home2Layout} />
        <Route path="/home-2" element={Home2Layout} />
        <Route path="/auth" element={<AuthPage />} />
        <Route
          path="/bmi-calculator"
          element={
            <div className="page-wraper">
              <Header2 />
              <WeightCalculator />
              <Footer2 />
            </div>
          }
        />
        <Route
          path="/libraries"
          element={
            <div className="page-wraper">
              <Header2 />
              <AboutUs />
              <Footer2 />
            </div>
          }
        />
        <Route
          path="/library/:slug"
          element={
            <ProtectedRoute>
              <div className="page-wraper">
                <Header2 />
                <LibraryPage />
                <Footer2 />
              </div>
            </ProtectedRoute>
          }
        />

        {/* My Schedule (accessible to all; shows login prompt if not authed) */}
        <Route
          path="/my-schedule"
          element={
            <div className="page-wraper">
              <Header2 />
              <MySchedulePage />
              <Footer2 />
            </div>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              {Home2Layout}
            </ProtectedRoute>
          }
        />

      </Routes>
    </AuthProvider>
  );
}

export default App;
